<template>
  <div class="volume-controller d-flex align-items-center justify-content-between">
    <div class="volume-controller--status border d-flex align-items-center justify-content-center" @click="mute">
      <VolumeXIcon v-if="formattedVolume === 0" size="14"></VolumeXIcon>
      <VolumeIcon v-else-if="formattedVolume > 0 && formattedVolume < 11" size="14"></VolumeIcon>
      <Volume1Icon v-else-if="formattedVolume > 10 && formattedVolume < 68" size="14"></Volume1Icon>
      <Volume2Icon v-else size="14"></Volume2Icon>
    </div>
    <div class="volume-controller--control d-flex align-items-center justify-content-center" :class="{'dark-mode': isDarkMode}">
      <b-form-input
        type="range"
        :value="volume"
        min="0"
        max="1"
        step="0.01"
        number
        @update="updateVolume"
      />
    </div>
    <div class="volume-controller--value border d-flex align-items-center justify-content-center">
      {{formattedVolume}}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Volume1Icon, Volume2Icon, VolumeXIcon, VolumeIcon } from "vue-feather-icons";
import { debounce } from "lodash-es";
export default {
  name: "VolumeController",
  props: {},
  components: {
    Volume1Icon,
    Volume2Icon,
    VolumeXIcon,
    VolumeIcon,
  },
  computed: {
    ...mapGetters("user", ["volume", "isDarkMode"]),
    formattedVolume() {
      return Math.ceil(this.volume * 100);
    },
  },
  methods: {
    updateVolume: debounce(function (value) {
      this.$store.commit("user/setVolume", Number(value));
    }, 300),
    mute() {
      this.$store.commit("user/setVolume", 0);
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.volume-controller {
  width: 100%;
  max-width: 100%;
  gap: 4px;

  &--status, &--value {
    cursor: pointer;
    border-radius: 3px;
    min-width: 24px;
    max-width: 24px;
    height: 24px;
  }

  &--value {
    font-size: 10px;
  }

  &--control {
    flex-grow: 1;

    input[type="range"] {
      &::-webkit-slider-thumb {
        background: #455a64;
        box-shadow: none;
      }
      &::-moz-range-thumb {
        background: #455a64;
        box-shadow: none;
      }
      &::-ms-thumb {
        background: #455a64;
        box-shadow: none;
      }
      &::-webkit-slider-runnable-track {
        background-color: rgba(#4f6873, 0.75);
      }
      &::-moz-range-track {
        background-color: rgba(#4f6873, 0.75);
      }
      &::-ms-track {
        background-color: rgba(#4f6873, 0.75);
      }
    }

    &.dark-mode {
      input[type="range"] {
        &::-webkit-slider-thumb {
          background: #b2b9bf;
        }
        &::-moz-range-thumb {
          background: #b2b9bf;
        }
        &::-ms-thumb {
          background: #b2b9bf;
        }
        &::-webkit-slider-runnable-track {
          background-color: rgba(#4f6873, 0.75);
        }
        &::-moz-range-track {
          background-color: #4f6873;
        }
        &::-ms-track {
          background-color: #4f6873;
        }
      }
    }
  }
}
</style>